/* Masha search panel: close shortly after the pointer leaves it (hover-capable desktops only).
   Touch devices keep tap-to-close. Only arms after the pointer has entered the panel,
   and never closes while there is text typed in the search box. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 750px)');

  function init() {
    var pane = document.getElementById('masha-search-pane');
    if (!pane) return;
    var inner = pane.querySelector('.masha-search-pane__inner');
    if (!inner) return;
    var input = document.getElementById('masha-search-input');
    var armed = false;
    var timer;

    function isOpen() {
      return pane.getAttribute('aria-hidden') === 'false';
    }

    new MutationObserver(function () {
      if (!isOpen()) {
        armed = false;
        clearTimeout(timer);
      }
    }).observe(pane, { attributes: true, attributeFilter: ['aria-hidden'] });

    inner.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      armed = true;
      clearTimeout(timer);
    });

    inner.addEventListener('mouseleave', function () {
      if (!mq.matches || !armed || !isOpen()) return;
      timer = setTimeout(function () {
        if (!isOpen()) return;
        if (input && input.value.trim() !== '') return;
        var btn = pane.querySelector('.masha-search-pane__close');
        if (btn) btn.click();
      }, 250);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
